// Выбор файла для загрузки. Фото и сканы принимаем, когда подключён ИИ (распознавание текста Vision OCR).
import { boot } from "../boot";

export const UPLOAD_ACCEPT = boot.aiEnabled ? ".pdf,.docx,.txt,.jpg,.jpeg,.png" : ".pdf,.docx,.txt";
export const READING = "Читаю документ — это займёт несколько секунд…";

// Несколько файлов сразу — для «Моих документов».
export function pickFiles(): Promise<File[]> {
  return new Promise((resolve) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = UPLOAD_ACCEPT;
    input.multiple = true;
    input.hidden = true;
    const done = (files: File[]) => { resolve(files); input.remove(); };
    input.addEventListener("change", () => done([...(input.files || [])]));
    input.addEventListener("cancel", () => done([]));
    document.body.append(input);
    input.click();
  });
}

// Окно выбора файла открываем сразу по нажатию (иначе браузер его не покажет), загружаем — после выбора.
export function pickFile(): Promise<File | null> {
  return new Promise((resolve) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = UPLOAD_ACCEPT;
    input.hidden = true;
    const done = (file: File | null) => { resolve(file); input.remove(); };
    input.addEventListener("change", () => done(input.files?.[0] || null));
    input.addEventListener("cancel", () => done(null));
    document.body.append(input);
    input.click();
  });
}
